import React, { Component } from 'react';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import { Modal, Table, Button } from 'react-bootstrap';
import swal from 'sweetalert';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import {bin} from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';
import { analiticalTestAddTestFromHc, analiticalTestByOffer, analiticalTestDelete, analiticalTestOption } from '../../libs/services';

class ModalAnaliticalTest extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSave = this.onSave.bind(this);
		this.getList = this.getList.bind(this);
		this.onDelete = this.onDelete.bind(this);

		this.state = {
		    show: false,
		    analitical_test_id:"",
		    analitical_test_name:"",
		    analitical_test:[],
		    new_value:"",
		    offers_id:"",
		    isLoading:false,
		    indice:-1,
		    list_test:[]
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}
	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ 
			show: false,
			analitical_test_id:"",
		    analitical_test:[],
		    new_value:"",
		    offers_id:"",
		    isLoading:false,
		    indice:-1,
		    list_test:[]
		});
	}

	async handleShow(offers_id) {
		await this.getList(offers_id);

		var response = await analiticalTestOption('for_donors');
		if(response !== undefined){
			this.setState({
				analitical_test: response,
				offers_id:offers_id,
				show: true
			})
		}
	}

	async getList(offers_id){
		var response = await analiticalTestByOffer(offers_id, this.props.waiting);
		if(response !== undefined){
			this.setState({list_test:response});
		}
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});
	}

	async onSave(){
		var obj = {
    		health_facilities_id:sessionStorage.getItem('health_facilities_id'), 
    		analitical_test_id:this.state.analitical_test_id,
    		offers_id:this.state.offers_id
		}

		if(this.state.analitical_test_id !== ""){
			var response = await analiticalTestAddTestFromHc(obj, this.props.waiting);
			if(response  !== undefined){
				swal('Correcto', 'Prueba agregada correctamente', 'success');
				this.getList(this.state.offers_id);			
			}
		}
	}

	handleTypeAheadChange = name => values => {
        if(values.length > 0){
    		this.setState({
    			isLoading:false,
	            [name]: values[0].analitical_test.id,
	            analitical_test_name: values[0].analitical_test.name,
	            indice:0,
	        });     	
        }
    }

    _handleSearch = (query) => {
	    this.setState({
	    	isLoading:true,
			indice:-1,
	    });
	}

	onDelete(e, obj){
		e.preventDefault();

		swal({
			title: '¿Desea eliminar la prueba?',
			text: '',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#DD6B55',
			confirmButtonText: '¡Si, Eliminar!',
			cancelButtonText: '¡No, Cancelar!',
			closeOnConfirm: true,
			closeOnCancel: true
		}, async (isConfirm)=> {
			if (isConfirm) {
				var response = await analiticalTestDelete(obj.id);
				if(response !== undefined){
					this.getList(this.state.offers_id);
				}
			}
		});
	}

	render(){
		const { t } = this.props;
		
		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Pruebas de Laboratorio</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{padding:"0px 20px 0px 20px"}}>
				        <div className="col-xs-12 form-group">
							<div className="col-xs-12 col-sm-8 col-sm-offset-2">
								<span>{t('content.results_donation.select_test')}:</span>
								<AsyncTypeahead
						          	labelKey={(option) => `${option.analitical_test.name}`}
						          	minLength={0}
						          	name="analitical_test"
						          	id="analitical_test" 
						          	inputProps={{
						          		autoComplete:"off",
						          		name:'analitical_test_id',
						          		id:'analitical_test_id'
						          	}}
						          	options={this.state.analitical_test}
						          	onSearch={this._handleSearch}
						          	onChange={ this.handleTypeAheadChange('analitical_test_id')} 
						          	ref={ref => this._typeahead = ref}
							        delay={600}
							        paginationText="Mostrar mas resultados..."
						        />
							</div>
							<div className="col-xs-12 col-sm-1" style={{paddingTop:"20px"}}>
							  	<FloatingActionButton className="action-btn" mini={true} iconStyle={{height: 23, width: 23}} 
							  		onClick={this.onSave}>
									<ContentAdd/>
							  	</FloatingActionButton>
							</div>

							{/*<div className="col-xs-12 col-sm-2">
								<span>{t('content.results_donation.value')}:</span>
								
								{this.state.analitical_test_id !== '' ?
									this.state.analitical_test.map((t, i) =>(
										(t.analitical_test.id === parseInt(this.state.analitical_test_id) ?
											t.analitical_test.type !== "CUALITATIVO" ?
												<input key={i} type="number" className="form-control" onChange={ this.handleChange }
															value={ this.state.new_value || "" } name="new_value" id="new_value" style={{textAlign:"right"}}/>
											
											: 	<select key={i} className="form-control" onChange={ this.handleChange }
													value={ this.state.new_value || i }
													name="new_value" id="new_value" >
													<option value="">Seleccionar...</option>
													{t.results.map((r)=>(
														   <option key={r.id}  value={r.value} >{r.value} </option>;
													))}
												</select>
										: false)
									))
								: <input className="form-control" disabled />
								}
							</div>
							*/}
							
				        </div>
				        <div className="col-xs-12">
				        	<Table responsive hover>
				        		<thead style={{display:'block'}}>
				        			<tr style={{width:'100%'}}>
				        				<th style={{width:'inherit'}}>Prueba</th>
				        				<th></th>
				        			</tr>
				        		</thead>
				        		<tbody style={{display:'block', height:'400px', overflowY:'auto'}}>
				        			{this.state.list_test.map((l, i)=>(
				        				<tr key={i} style={{width:'100%'}}>
				        					<td style={{width:'inherit'}}>{l.test_name}</td>
				        					<td>
				        						{l.can_edit ? 
				        							<Button className="btn btn-info btn-xs" title="Eliminar" 
				        								style={{marginRight:'3px'}} 
					        							onClick={(e)=>this.onDelete(e, l)}>
							                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
							                        </Button>
				        						:null}
					        						
				        					</td>
				        				</tr>
				        			))}
				        		</tbody>
				        	</Table>
				        </div>
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	{/*<FlatButton primary={true} label={t('content.generics.buttons.save')}  onClick={this.onSave}/>*/}
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalAnaliticalTest) 